import axios from "axios";

const API_PATH = '/manage/companies';

const FetchSource = async searches => (
	await axios.get(API_PATH, { params: searches })
);

const FetchValidateEmail = async searches => (
	await axios.get(`${API_PATH}/validate`, { params: searches })
);

const FetchBusinessManagers = async ({ bId, searches }) => (
	await axios.get(`${API_PATH}/${bId}/business-managers`, { params: searches })
);

const CreateCompaniesManagers = async source => (
	await axios.post(API_PATH, source)
);

const EditCompaniesManagers = async ({ bId, source }) => (
	await axios.put(`${API_PATH}/${bId}`, source)
);

export { FetchSource, FetchValidateEmail, CreateCompaniesManagers, FetchBusinessManagers, EditCompaniesManagers } ;
